export { default } from './CopyStylesModalConnector';
